// stageSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  ev_stage: null,
};

const stageSlice = createSlice({
  name: 'ev_stage',
  initialState,
  reducers: {
    setStage: (state, action) => {
      state.ev_stage = action.payload;
    },
    clearStage: (state) => {
      state.ev_stage = null;
    },
  },
});

export const { setStage, clearStage } = stageSlice.actions;
export default stageSlice.reducer;
